import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

const DEFAULT_RETURN_WINDOW = 60;

interface HasDefaultReturnWindow {
  hasDefaultReturnWindow: boolean;
  setHasDefaultReturnWindow: (retailer: Partial<IRetailer>) => void;
}

export const useZustandHasDefaultReturnWindow = create<HasDefaultReturnWindow>(
  (set) => ({
    hasDefaultReturnWindow: false,
    setHasDefaultReturnWindow: (retailer) => {
      set({
        hasDefaultReturnWindow:
          (retailer?.return_window_days ?? DEFAULT_RETURN_WINDOW) ===
          DEFAULT_RETURN_WINDOW,
      });
    },
  })
);

const useHasDefaultReturnWindowControl = () => {
  const { hasDefaultReturnWindow } = useRetailerStore([
    "hasDefaultReturnWindow",
  ]);

  return { hasDefaultReturnWindow };
};

export const useHasDefaultReturnWindow = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandHasDefaultReturnWindow();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useHasDefaultReturnWindowControl();
};
